import { useEffect } from 'react'

/**
 * Belt-and-braces: ensures noindex/nofollow stays on every render even if
 * something downstream alters <head>. The static index.html and Cloudflare
 * Pages _headers also set this, so this hook is a third line of defence.
 */
export function PrivacyMeta() {
  useEffect(() => {
    const ensureMeta = (name: string, content: string) => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute('name', name)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }
    ensureMeta('robots', 'noindex,nofollow')
    ensureMeta('referrer', 'same-origin')
  }, [])

  return null
}
